import React from "react";
import type { TextInputProps, ViewStyle } from "react-native";
import type { LucideIcon } from "lucide-react-native";
import { TextField, colors } from "@louise/moon-ui";

type MedicalHistoryTextFieldProps = Omit<TextInputProps, "style"> & {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  loading?: boolean;
  icon?: LucideIcon;
  /** Use when the label is owned by an outer MoonFormField. */
  labelIcon?: LucideIcon;
  style?: ViewStyle;
  testID?: string;
  appearance?: "light" | "dark" | "auto";
};

/**
 * The text field used by Medical History detail forms, on the shared
 * `TextField`. With a label, `icon` sits on the label; without one (when an
 * outer MoonFormField owns the label), it sits inside the box.
 */
export function MedicalHistoryTextField({
  label,
  hint,
  error,
  required,
  disabled,
  loading,
  icon: Icon,
  labelIcon,
  style,
  testID,
  appearance: _appearance,
  multiline,
  ...props
}: MedicalHistoryTextFieldProps) {
  return (
    <TextField
      {...props}
      label={label}
      labelIcon={label ? (labelIcon ?? Icon) : undefined}
      hint={hint}
      error={error}
      required={required}
      disabled={disabled}
      loading={loading}
      notes={Boolean(multiline)}
      leading={
        !label && Icon ? <Icon size={16} color={colors.textFaint} /> : null
      }
      style={style}
      testID={testID}
    />
  );
}
